module.exports = __webpack_public_path__ + "static/media/mickierony.f6c922b4.jpeg";